'use strict'

import axios from 'axios'
import {parseResponse, handleError} from '@/_helpers/utils.js'

export default {
  xlsExport (params) {
    return axios.get('/1.0/spec-private/sibur-st/responses/report/xls', {params})
      .then(response => {
        return parseResponse(response)
      })
      .catch(err => {
        throw handleError(err)
      })
  }
}
